<template>
  <div class="container">
    <h4 class="title is-4">Log</h4>
    <b-table
        v-if="tableData.length > 0"
        :narrowed="true"
        :striped="true"
        :data="tableData"
    >
      <template slot-scope="props">
        <b-table-column field="num" numeric>{{props.row.num}}</b-table-column>
        <b-table-column field="timestamp" label="Time" centered>{{props.row.localTime}}</b-table-column>
        <b-table-column field="message" label="Message">{{props.row.message}}</b-table-column>
      </template>
    </b-table>
    <div v-else>No log data, yet.</div>
    <div>
      <hr/>
      This is the log gathered since the last engine restart.
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import {mapGetters} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import {formatTime} from '../utils/utils.js';

  export default {
    components: {
      BTableColumn,
      BTable
    },
    name: "screenlog",
    data() {
      return {};
    },
    computed: {
      ...mapGetters('mqtt', ['tailFeedbackHistory']),
      tableData() {
        const data = this.tailFeedbackHistory({
          topic: 'feedback/data'
        });
        let num = 0;
        return data.map(item => {
          num++;
          let payload = {
            timestamp: 0,
            message: ''
          };
          try {
            payload = JSON.parse(item.message);
          } catch (e) {
            /* eslint-disable */
            console.log(e);
          }
          const localTime = formatTime(parseInt(moment(payload.timestamp).format('X'), 10));
          return {
            ...item,
            timestamp: payload.timestamp,
            localTime: localTime,
            message: payload.message,
            num
          };
        });
      }
    }
  }
</script>

<style scoped>

</style>